<template>
  <section class="hero-section" :style="{ backgroundImage: 'url(@/assets/hero-background.jpg)' }">
    <div class="hero-content">
      <h1 class="hero-title">Unleash the Beast with Devil's Mistress</h1>

      <!-- Video Element -->
      <video class="hero-video" src="@/assets/TriggerClip.mp4" autoplay loop muted playsinline></video>

      <p class="hero-subtext">
        Precision, Power, Perfection. Elevate your shot with the most advanced on the market.
      </p>
      <div class="hero-buttons">
        <button class="hero-btn primary-btn">Shop Now</button>
        <button class="hero-btn secondary-btn">Learn More</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
};
</script>

<style scoped>
.hero-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
  color: white;
  background-size: cover;
  background-position: center;
  position: relative;
  text-align: center;
}

.hero-content {
  max-width: 80%;
  background-color: rgba(0, 0, 0, 0.6); /* Optional: dark overlay for readability */
  padding: 20px;
  border-radius: 8px;
}

.hero-title {
  font-size: 3em;
  font-weight: bold;
}

.hero-video {
  width: 100%; /* Adjust width as needed */
  max-width: 600px;
  margin: 20px auto;
  border-radius: 8px;
}

.hero-subtext {
  font-size: 1.2em;
  margin: 10px 0;
}

.hero-buttons {
  margin-top: 20px;
}

.hero-btn {
  padding: 10px 20px;
  font-size: 1em;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 5px;
}

.primary-btn {
  background-color: crimson;
  color: white;
}

.secondary-btn {
  background-color: gray;
  color: white;
}
</style>
